import React , {createContext , useState , useContext, Children} from 'react';

const prescriptionDetectorContext = createContext();

export const usePrescriptionDetectorAuth = () => {
    return useContext(prescriptionDetectorContext);
}


export const PrescriptionDetectorAuthProvider = ({children}) => {
    const isAuth = !localStorage.getItem('presdecttoken');
    const [isPresDectAuthenticated , setIsJobDescAuthenticated] = useState(!isAuth);


    const presDectLogin = () => {
        setIsJobDescAuthenticated(true);
    };

    const presDectLogout = () => {
        setIsJobDescAuthenticated(false);
    };


    return (
        <prescriptionDetectorContext.Provider value={{isPresDectAuthenticated , presDectLogin , presDectLogout}}>
            {children}
        </prescriptionDetectorContext.Provider>
    )
}